import React, {Component} from 'react';
import {injectIntl} from "react-intl";
import Constants from "../../services/Constants";
import {Divider, Tabs} from "antd";
import SATextArea from "../common/input/SATextArea";
import SAInput from "../common/input/SAInput";
import SAInputCurrency from "../common/input/SAInputCurrency";
import SAInputComponent from "../common/input/SAInputComponent";
import connect from "react-redux/es/connect/connect";

const {TabPane} = Tabs;

class RentalContractConfiguration extends Component {

  constructor(props) {
    super(props)
    this.state = {
      configuration: this.props.configuration
    }
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.configuration) {
      this.setState({configuration: nextProps.configuration});
    }
  }

  onFieldUpdate = (name, value) => {
    const {onUpdate} = this.props;
    const {configuration = {}} = this.state;
    configuration[name] = value;
    this.setState({configuration})
    onUpdate(configuration);
  };

  onLangFieldUpdate = (e, lang) => {
    const {onUpdate} = this.props;
    const {configuration = {}} = this.state;
    const {name, value} = e.target;
    configuration[name] = configuration[name] || {};
    configuration[name][lang] = value;
    this.setState({configuration})
    onUpdate(configuration);
  };

  render() {
    const {intl: {formatMessage}, errors = {}, configurationHints} = this.props;
    const {configuration = {}} = this.props;
    const {roadFineCharge, excessiveUseCharge, missingFuelCharge} = configuration;


    const requiredConfig = configurationHints.includes('RENTAL_CONFIGURATION_CONFIGURATION');
    return (
      <div className="box__body">

        {requiredConfig && <div className={"alert alert--error"}>{formatMessage({id: 'section.requires-configuration'}, {sectionName: formatMessage({id: 'mobility.rental-contract.configuration'})})}</div>}

        <h3 className="box__subtitle">
          {formatMessage({id: 'mobility.rental-contract.configuration'})} ({formatMessage({id: 'exclude.vat'})})
        </h3>

        <div className="row">
          <div className="col-sm-12 col-xxl-4">
            <SAInputComponent label={formatMessage({id: 'mobility.administrative-fee.fine'})}>
              <SAInputCurrency onChange={value => this.onFieldUpdate('roadFineCharge', value)} value={roadFineCharge}
                               min={0} step={0.1} error={errors['rentalContractConfiguration'] || errors['rentalContractConfiguration.roadFineCharge']}/>
            </SAInputComponent>
          </div>
          <div className="col-sm-12 col-xxl-4">
            <SAInputComponent label={formatMessage({id: 'mobility.administrative-fee.exceeded-usage'})}>
              <SAInputCurrency onChange={value => this.onFieldUpdate('excessiveUseCharge', value)} value={excessiveUseCharge}
                               min={0} step={0.1} error={errors['rentalContractConfiguration'] || errors['rentalContractConfiguration.excessiveUseCharge']}/>
            </SAInputComponent>
          </div>
          <div className="col-sm-12 col-xxl-4">
            <SAInputComponent label={formatMessage({id: 'mobility.administrative-fee.refueling'})}>
              <SAInputCurrency onChange={value => this.onFieldUpdate('missingFuelCharge', value)} value={missingFuelCharge}
                               min={0} step={0.1} error={errors['rentalContractConfiguration'] || errors['rentalContractConfiguration.missingFuelCharge']}/>
            </SAInputComponent>
          </div>
        </div>
        <Divider className="b-xxl"/>
        <div className="row">
          <div className="col-md-12 col-xl-6 mt-5">
            <h3 className="box__subtitle">{formatMessage({id: 'mobility.drive-zone'})}</h3>
            <Tabs type="card" defaultActiveKey="en">
              {Constants.SUPPORTED_LANGUAGES.map(lang => {
                const error = errors['rentalContractConfiguration'] || errors['rentalContractConfiguration.driveZone'] || errors[`rentalContractConfiguration.driveZone.${lang}`]
                return <TabPane tab={<span className={error ? 'txt-error' : ''}>{formatMessage({id: lang})}</span>} key={lang}>
                  <SAInput name="driveZone" value={configuration.driveZone && configuration.driveZone[lang]}
                           onChange={e => this.onLangFieldUpdate(e, lang)}
                           error={error}/>
                </TabPane>
              })}
            </Tabs>
          </div>

          <div className="col-md-12 col-xl-6 mt-5">
            <h3 className="box__subtitle">{formatMessage({id: 'mobility.contract.footer'})}</h3>
            <Tabs type="card" defaultActiveKey="en">
              {Constants.SUPPORTED_LANGUAGES.map(lang => {
                const error = errors['rentalContractConfiguration'] || errors['rentalContractConfiguration.contractFooter'] || errors[`rentalContractConfiguration.contractFooter.${lang}`]
                return <TabPane tab={<span className={error ? 'txt-error' : ''}>{formatMessage({id: lang})}</span>} key={lang}>
                  <SATextArea name="contractFooter"
                              value={configuration.contractFooter && configuration.contractFooter[lang]}
                              onChange={e => this.onLangFieldUpdate(e, lang)}
                              error={error}/>

                </TabPane>
              })}
            </Tabs>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  configurationHints: (state.dealerConfigurationCheck && state.dealerConfigurationCheck.configurationHints) || [],
});


export default connect(mapStateToProps)(injectIntl(RentalContractConfiguration));
